import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { getFollowSettings, saveFollowSettings } from './thunk'

const initialState = {
  originSettings: {},
  settings: {},

  loading: {
    settings: true,
    saveSettings: false,
  },
}

const slice = createSlice({
  name: 'common/popupFollowAlert',
  initialState,
  reducers: {
    resetStore: () => initialState,
    changeSettings: (state, action) => {
      state.settings = {
        ...state.settings,
        ...action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    //getFollowSettings
    builder.addCase(getFollowSettings.pending, (state) => {
      state.loading.settings = true
    })
    builder.addCase(getFollowSettings.fulfilled, (state, action) => {
      state.originSettings = action.payload
      state.settings = action.payload
      state.loading.settings = false
    })
    builder.addCase(getFollowSettings.rejected, (state) => {
      state.settings = {}
      state.loading.settings = false
    })
    //saveFollowSettings
    builder.addCase(saveFollowSettings.pending, (state) => {
      state.loading.saveSettings = true
    })
    builder.addCase(saveFollowSettings.fulfilled, (state, action) => {
      state.originSettings = JSON.parse(JSON.stringify(state.settings))
      state.loading.saveSettings = false
    })
    builder.addCase(saveFollowSettings.rejected, (state) => {
      state.loading.saveSettings = false
    })
  },
})

export const { resetStore, changeSettings } = slice.actions

export const selectOriginSettings = (state) => state[slice.name].originSettings
export const selectSettings = (key) => (state) => {
  const settings = state[slice.name].settings
  if (!key) return settings
  return settings[key]
}

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return state[slice.name].loading[type]
}

register(slice.name, slice.reducer)
